import { Component, Input, OnInit } from '@angular/core';
import { AufgabeFacade, AufgabeLinkRel, AufgabeResource, AufgabeService } from '@schir-int-client/aufgabe-shared';
import { StateResource } from '@schir-int-client/ngrx-helpers';
import { VerfuegungResource, VerfuegungTyp } from '@schir-int-client/verfuegung-shared';
import { Observable } from 'rxjs';
import { CreateAufgabeDialogComponent } from '../create-aufgabe-dialog/create-aufgabe-dialog.component';
import { DialogService, HandlesBackdropClickAndEscapeKey } from '@schir-int-client/tech';
import { hasLink } from '@ngxp/rest';
import { CreateKorrespondenzDialogComponent } from '../create-korrespondenz-dialog/create-korrespondenz-dialog.component';
import { VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { take } from 'rxjs/operators';
import { RegisterName } from '@schir-int-client/register-shared';

@Component({
	selector: 'schir-int-client-aufgaben-in-verfuegung',
	templateUrl: './aufgaben-in-verfuegung.component.html',
	styleUrls: ['./aufgaben-in-verfuegung.component.scss'],
	standalone: false,
})
export class AufgabenInVerfuegungComponent
	extends HandlesBackdropClickAndEscapeKey<CreateAufgabeDialogComponent | CreateKorrespondenzDialogComponent>
	implements OnInit
{
	@Input() verfuegung: VerfuegungResource;

	aufgaben: Observable<StateResource<AufgabeResource[]>>;
	private register: RegisterName;

	constructor(
		private aufgabeFacade: AufgabeFacade,
		private verfahrenFacade: VerfahrenFacade,
		protected dialogService: DialogService
	) {
		super(dialogService);

		this.aufgaben = aufgabeFacade.getAufgaben();
	}

	ngOnInit(): void {
		this.verfahrenFacade.verfahrenSingle.pipe(take(1)).subscribe(v => {
			this.register = v.register;
		});
	}

	openAufgabeDialog(editMode = false, excludeEingetrageneEigentuemer = true) {
		this.matDialogRef = this.dialogService.openEditorDialog(this, CreateAufgabeDialogComponent, {
			data: {
				verfuegung: this.verfuegung,
				editMode: editMode,
				excludeEingetragenerEigentuemer: excludeEingetrageneEigentuemer,
			},
		});
	}

	openKorrespondenz(aufgabe) {
		this.aufgabeFacade.setAufgabe(aufgabe);
		if (hasLink(aufgabe, AufgabeLinkRel.KORRESPONDENZ_VORLAGE)) {
			this.aufgabeFacade.downloadKorrespondenz();
		} else {
			this.matDialogRef = this.dialogService.openEditorDialog(this, CreateKorrespondenzDialogComponent);
		}
	}

	sort(aufgaben: AufgabeResource[]): AufgabeResource[] {
		return AufgabeService.sortAufgabenByTyp(aufgaben, this.register);
	}

	isKorrespondenz(verfuegung) {
		return verfuegung.typ == VerfuegungTyp.KORRESPONDENZ;
	}
}
